import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/enrollment/")({
    component: RouteComponent,
    beforeLoad: () => {
        throw redirect({
            to: "/dashboard/enrollment/fields",
        });
    },
});

function RouteComponent() {
    return null;
}
